const DEVICE_ID_KEY = 'deviceId';

function generateDeviceId() {
  const bytes = new Uint8Array(16);

  if (window.crypto?.getRandomValues) {
    window.crypto.getRandomValues(bytes);
  } else {
    for (let i = 0; i < bytes.length; i += 1) {
      bytes[i] = Math.floor(Math.random() * 256);
    }
  }

  return `dev-${Array.from(bytes).map((value) => value.toString(16).padStart(2, '0')).join('')}`;
}

export function getOrCreateDeviceId() {
  const existingValue = localStorage.getItem(DEVICE_ID_KEY);

  if (existingValue && existingValue.trim()) {
    return existingValue.trim();
  }

  const newDeviceId = generateDeviceId();
  localStorage.setItem(DEVICE_ID_KEY, newDeviceId);
  return newDeviceId;
}

export function clearDeviceId() {
  localStorage.removeItem(DEVICE_ID_KEY);
}
